/* eslint-disable no-restricted-imports */
import React from 'react'
import { ReactComponent as CloudSoftware } from '@toasttab/shared/src/assets/svg/other/cloud-software.svg'
import { ReactComponent as Intuitive } from '@toasttab/shared/src/assets/svg/other/intuitive.svg'
import { ReactComponent as Connect } from '@toasttab/shared/src/assets/svg/other/connect.svg'
import { ReactComponent as FlatRatePricing } from '@toasttab/shared/src/assets/svg/other/flat-rate-pricing.svg'
import { ReactComponent as NoHiddenFees } from '@toasttab/shared/src/assets/svg/other/no-hidden-fees.svg'
import { ReactComponent as CustomerCare } from '@toasttab/shared/src/assets/svg/other/customer-care.svg'
import { ReactComponent as RestaurauntGradeHardware } from '@toasttab/shared/src/assets/svg/other/restauraunt-grade-hardware.svg'
import { ReactComponent as LineWait } from '@toasttab/shared/src/assets/svg/other/line-wait.svg'
import { ReactComponent as PencilRuler } from '@toasttab/shared/src/assets/svg/other/pencil-ruler.svg'

interface IconProps {
  iconType:
    | 'cloud-software'
    | 'intuitive'
    | 'connect'
    | 'flat-rate-pricing'
    | 'no-hidden-fees'
    | 'customer-care'
    | 'restauraunt-grade-hardware'
    | 'line-wait'
    | 'pencil-ruler'
}

const Icon = ({ iconType }: IconProps) => {
  let icon: any = null
  switch (iconType) {
    case 'cloud-software':
      icon = <CloudSoftware height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'intuitive':
      icon = <Intuitive height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'connect':
      icon = <Connect height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'flat-rate-pricing':
      icon = <FlatRatePricing height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'no-hidden-fees':
      icon = <NoHiddenFees height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'customer-care':
      icon = <CustomerCare height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'restauraunt-grade-hardware':
      icon = (
        <RestaurauntGradeHardware height='25' viewBox='0 0 64 64' width='25' />
      )
      break
    case 'line-wait':
      icon = <LineWait height='25' viewBox='0 0 64 64' width='25' />
      break
    case 'pencil-ruler':
      icon = <PencilRuler height='25' viewBox='0 0 25 25' width='25' />
      break
    default:
      icon = null
  }
  return icon
}

export default Icon
